<h6 class="d-flex align-items-center">
  <span>{{ field.Name }}</span>
  @if (field.Deprecation) {
    <mat-icon class="warning ml-2" [matTooltip]="field.Deprecation">warning</mat-icon>
  }
  @if (field.Description) {
    <mat-icon class="ml-2" [matTooltip]="field.Description">info</mat-icon>
  }
</h6>

<div class="main-container">
  <div class="line"></div>
  <div class="forms-container">
    <form [formGroup]="form">
      @for (field of field.Fields; track field) {
        <div class="form-container align-items-center">
          <div class="plus-dots"></div>
          <eva-ui-editor-element [formControlName]="field.Name" [field]="field"></eva-ui-editor-element>
        </div>
      }
    </form>
  </div>

</div>
